import { render } from "./ModalEditSubgrupo.vue?vue&type=template&id=bb97a7c8&ts=true"
import script from "./ModalEditSubgrupo.vue?vue&type=script&lang=ts"
export * from "./ModalEditSubgrupo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__